import { Directive, ElementRef, inject, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[lfxShowMore]',
  standalone: true,
})
export class ShowMoreDirective implements OnInit {
  @Input() public maxLength: number;

  public originalText: string = '';
  public basicText: string = '';

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  public ngOnInit() {
    // Store the original HTML content of the element
    this.originalText = this.el.nativeElement.innerHTML;
    // Set basic text as the original text with html tags removed.
    this.basicText = this.originalText.replace(/<[^>]*>/g, '');
    // Check if the basic text length exceeds the maximum length
    if (this.basicText.length > this.maxLength) {
      // Truncate the text and add show more link
      this.truncateText();
    }
  }

  private truncateText() {
    // Create a truncated version of the original text
    const truncatedText = this.originalText.substring(0, this.maxLength) + '... ';
    // Set the truncated text as the innerHTML of the element
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', truncatedText);
    // Append the show more link
    this.appendShowMoreLink();
  }

  private showFullText() {
    // Set the original text as the innerHTML of the element to show the full text
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.originalText + ' ');
    // Append the show less link
    this.appendShowLessLink();
  }

  private appendShowMoreLink() {
    // Create a link element for showing more text
    const moreLink = this.renderer.createElement('a');
    // Set the innerHTML of the link element
    this.renderer.setProperty(moreLink, 'innerHTML', 'show more');
    // Set the cursor style of the link element
    this.renderer.setStyle(moreLink, 'cursor', 'pointer');
    // Set the color of the link element
    this.renderer.setStyle(moreLink, 'color', '#0094ff');
    // Set the onclick event handler to show the full text
    this.renderer.setProperty(moreLink, 'onclick', () => this.showFullText());
    // Append the link element to the directive's host element
    this.renderer.appendChild(this.el.nativeElement, moreLink);
  }

  private appendShowLessLink() {
    // Create a link element for showing less text
    const lessLink = this.renderer.createElement('a');
    // Set the innerHTML of the link element
    this.renderer.setProperty(lessLink, 'innerHTML', 'show less');
    // Set the cursor style of the link element
    this.renderer.setStyle(lessLink, 'cursor', 'pointer');
    // Set the color of the link element
    this.renderer.setStyle(lessLink, 'color', '#0094ff');
    // Set the onclick event handler to truncate the text
    this.renderer.setProperty(lessLink, 'onclick', () => this.truncateText());
    // Append the link element to the directive's host element
    this.renderer.appendChild(this.el.nativeElement, lessLink);
  }
}
